import { render, staticRenderFns } from "./aboutArea.vue?vue&type=template&id=5b107418&scoped=true"
var script = {}
import style0 from "./aboutArea.vue?vue&type=style&index=0&id=5b107418&prod&scoped=true&lang=css"
import style1 from "./aboutArea.vue?vue&type=style&index=1&id=5b107418&prod&scoped=true&lang=css"
import style2 from "./aboutArea.vue?vue&type=style&index=2&id=5b107418&prod&scoped=true&lang=css"
import style3 from "./aboutArea.vue?vue&type=style&index=3&id=5b107418&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b107418",
  null
  
)

export default component.exports